import { Resource as e, API as a } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Returns a paginated list of hosted pages for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve hosted pages.
   * @param {ListHostedPagesParams} options Options to configure the request.
   * @returns {Promise<PageModel<HostedPageResponse>>} Paginated list of hosted pages for the specified project.
   */
  listHostedPagesByProjectId(i, r = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/pages`, {
        ...r,
        projectId: i
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/hostedpages`;
let s = t;
export {
  s as HostedPagesInternalResource
};
//# sourceMappingURL=HostedPagesInternalResource.js.map
